import LabelText from "./text/labelText.vue"
import CopyText from "./text/copy-text.vue"
import TableButton from "./button/tableButton.vue"
import BasicTable from "./table/basicTable.vue"
import PageTable from "./table/pageTable.vue"
import DataTable from "./table/dataTable.vue"
import MultipleSelect from "./select/multipleSelect.vue"
import SelectInput from "./input/selectInput.vue"
import SearchInput from "./input/searchInput.vue"
import RangeInput from "./input/rangeInput.vue"

import DetailDescriptions from './descriptions/detail-descriptions.vue'

import WangEditor from "./editor/wangEditor.vue"
import EditTabs from './tabs/edit-tabs.vue'


export default {
  LabelText,
  CopyText,
  TableButton,
  BasicTable,
  PageTable,
  DataTable,
  MultipleSelect,
  SelectInput,
  SearchInput,
  RangeInput,
  DetailDescriptions,

  WangEditor,
  EditTabs,
}
